import script from "./PatientTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientTable.vue?vue&type=script&setup=true&lang=js"

import "./PatientTable.vue?vue&type=style&index=0&id=0853722e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0853722e"]])

export default __exports__